window.addEventListener('storage',function(e){
    console.log(e,"e")
    // alert('change outside')
    // else, event is caused by an update to localStorage, ignore it
 });

 window.onbeforeunload = () => {
    console.log("on unload")
  }
// onunload

// onbeforeunload

// close

// unload

